module.exports = __webpack_public_path__ + "53ae217199c8f1ac2666e84f20d829a6.svg";